var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('title-bar'),_c('div',{staticClass:"horizontal-spacer"}),_c('notice-banner'),_c('div',{staticClass:"horizontal-spacer"}),_c('page-body'),_c('div',{staticClass:"horizontal-spacer"}),_c('footer-bar'),_c('div',{staticClass:"horizontal-spacer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }